/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Protocol from "core/models/protocol";
import OlaparibFollowingComponent from "../olaparib-following/index";
export default class TreatmentHistoryEditionFormProtocolsViewProtocolSectionsOlaparibComponent extends OlaparibFollowingComponent {
  get protocolModel() {
    return Protocol.new(this.args.changeset.data);
  }
  get canBePaused() {
    return this.protocolModel.canBePaused;
  }
}